import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import Loader from "../../components/Loader";
import { BRAND_COLOR } from "../../constants";
import { useGoogleReCaptcha } from "@google-recaptcha/react";
import useValidateReCaptchaMutation from "../../hooks/useValidateReCaptchaMutation";

const Login = () => {
	const intl = useIntl();
	const googleReCaptcha = useGoogleReCaptcha();

	const auth = useAuth();
	const navigate = useNavigate();

	const [authenticationInProgress, setAuthenticationInProgress] = useState(false);
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");

	const reCaptchaMutation = useValidateReCaptchaMutation();

	const handleLogin = async () => {
		setAuthenticationInProgress(true);

		if (!password || !username || !googleReCaptcha) {
			alert(intl.formatMessage({ id: "login_failed" }));
			setAuthenticationInProgress(false);
			return;
		}

		// @ts-expect-error not handled by types yet
		const token = await googleReCaptcha.executeV3("action");
		const response = await reCaptchaMutation.mutateAsync({ captcha: token });
		
		if (!response) {
			alert(intl.formatMessage({ id: "login_failed" }));
			return;
		}

		await auth.login(username, password);

		if (await auth.login(username, password)) {
			navigate("/backoffice", { replace: true });
		} else {
			alert(intl.formatMessage({ id: "login_failed" }));
		}

		setAuthenticationInProgress(false);
	};

	return (
		<div className="container mt-5">
			<h2>{intl.formatMessage({ id: "login_welcome" })}</h2>
			<h4>{intl.formatMessage({ id: "login_hint" })}</h4>
			<input
				className="form-control mb-2"
				placeholder={intl.formatMessage({ id: "login_username" })}
				onChange={(e) => setUsername(e.target.value)}
			/>
			<input
				type="password"
				className="form-control mb-2"
				placeholder={intl.formatMessage({ id: "login_password" })}
				onChange={(e) => setPassword(e.target.value)}
			/>
			{authenticationInProgress ? (
				<Loader title="Authentication is progress" message={intl.formatMessage({ id: "please_wait" })} />
			) : null}
			<button
				disabled={authenticationInProgress}
				style={{ backgroundColor: BRAND_COLOR }}
				className="btn w-100 text-light p-2"
				onClick={handleLogin}
			>
				{intl.formatMessage({ id: "login_button" })}
			</button>
		</div>
	);
};

export default Login;
